import { z } from 'zod';
export const forgotPasswordSchema = z.object({
    email: z.string().email('Invalid email format'),
    redirectTo: z.string().url().optional(),
});
//# sourceMappingURL=forgot-password.schema.js.map